import IconDownloading from "./download.svg?react";
import IconDownSuccess from "./success.svg?react";
import { handleStatus411 } from "@apis/hooks";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import report from "@report";
import { DownloadingItem, finishDownloadVideo } from "@store/globalVideoSlice";
import { updateFeautreDownloadVideo } from "@store/memberCenterSlice";
import message from "@utils/message";

import axios, { CanceledError } from "axios";
import FileDownload from "js-file-download";
import { useEffect, useRef, useState } from "react";
import { Trans } from "react-i18next";

interface VideoItemProps {
  downloadItem: DownloadingItem;
}

export default ({ downloadItem }: VideoItemProps) => {
  const dispatch = useAppDispatch();
  const { region } = useAppSelector((state) => state.globalReducer);
  const refWrapper = useRef<null | HTMLDivElement>(null);
  const refProgress = useRef<null | HTMLDivElement>(null);
  const [progress, setProgress] = useState(0);
  const refProgressNum = useRef(0);
  const [isFinish, setFinish] = useState(false);
  const [permission, setPermission] = useState(true);
  const abortControllerRef = useRef<AbortController>(new AbortController());

  const updateProgressUI = (progressNum: number) => {
    if (progressNum >= 0 && progressNum <= 100) {
      if (refWrapper && refWrapper.current) {
        refWrapper.current
          .querySelector(".loading_circle")
          ?.setAttribute("stroke-dashoffset", String(125 - progressNum * 1.25));
      }
      setProgress(progressNum);
    }
  };
  useEffect(() => {
    report.event("download_video", { kalo_value: downloadItem.videoId });
    updateProgressUI(0);

    const timer = setInterval(() => {
      if (refProgressNum.current < 99) {
        refProgressNum.current = refProgressNum.current + 1;
        updateProgressUI(refProgressNum.current);
      }
    }, 500);

    axios({
      url: `/video/detail/downloadVideo?videoId=${downloadItem.videoId}&country=${region}`,
      signal: abortControllerRef.current.signal,
      responseType: "blob",
      headers: { Country: region },
      onDownloadProgress: (progressEvent) => {
        if (progressEvent.srcElement.status === 206) {
          if (permission === false) {
            setPermission(true);
          }
          const loaded = progressEvent.loaded;
          const total = progressEvent.srcElement.getResponseHeader("content-range").split("/")[1];
          const progress = ((loaded / total) * 100).toFixed(0);

          if (refProgress) {
            const progressNum = Number(progress);

            if (progressNum > refProgressNum.current) {
              updateProgressUI(progressNum);
              clearInterval(timer);
            }
          }
        }
      },
    })
      .then((response) => {
        if (response.data.type.indexOf("video") >= 0) {
          FileDownload(response.data, `video_${downloadItem.videoId}.mp4`);
        } else if (response.status === 200) {
          message.error(
            "Your download limit has been reached. Please go to the pricing page to purchase the recharge plan.",
          );
        } else if (response.status === 404) {
          message.error("The video is being prepared. Please wait approximately 30 seconds and try downloading again.");
        } else {
          message.error("Server error");
        }
        dispatch(finishDownloadVideo(downloadItem.videoId));
        setTimeout(() => {
          setFinish(true);
        }, 2000);
        report.event("download_video_success", { kalo_value: downloadItem.videoId });
      })
      .catch((error) => {
        if (error.response?.status === 411) {
          handleStatus411();
          return;
        }
        if (error instanceof CanceledError) {
        } else {
          message.error("Download Failed, Retry.");
          report.event("download_video_failed", { kalo_value: downloadItem.videoId });
        }
        dispatch(finishDownloadVideo(downloadItem.videoId));
        setFinish(true);
      });
    dispatch(updateFeautreDownloadVideo());

    return () => {
      refProgressNum.current = 0;
      clearInterval(timer);
    };
  }, []);

  if (permission) {
    return (
      <div className="item">
        {!isFinish && (
          <div className="downloading" ref={refWrapper}>
            <IconDownloading className="icon"></IconDownloading>
            <div>
              <Trans>Downloaded</Trans> <span ref={refProgress}>{progress}</span>%
            </div>
            <div
              className="cancel"
              onClick={() => {
                abortControllerRef.current.abort();
              }}
            >
              <Trans>Cancel</Trans>
            </div>
          </div>
        )}
        {isFinish && (
          <div className="finish" ref={refWrapper}>
            <IconDownSuccess className="icon"></IconDownSuccess>
            <div className="text">
              <Trans>Download complete</Trans>
            </div>
          </div>
        )}
      </div>
    );
  }
  return null;
};
